import loadable from "@loadable/component";
import { useAppContext } from "contexts/app.context";
import { ModalTypeValue } from "enums/modalType";
import { isMobile } from "router";
import ModalAnnouncement from "./ModalAnnouncement";

const LoginModalDesktop = loadable(() => import("./LoginModal/Desktop"));
const LoginModalMobile = loadable(() => import("./LoginModal/Mobile"));
const RegisterModal = loadable(() => import("./RegisterModal"));
const ForgotPasswordModal = loadable(() => import("./ForgotPasswordModal"));
const AddBankModal = loadable(() => import("./AddBankModal"));
const ModalGameTransferPoint = loadable(() => import("./ModalGameTransferPoint"));
const RollCallModal = loadable(() => import("./CheckIn"));

export const Modal = () => {
  const { state } = useAppContext();
  return (
    <>
      {isMobile ? <LoginModalMobile /> : <LoginModalDesktop />}
      {state.openModal === ModalTypeValue.REGISTER ? <RegisterModal /> : null}
      <ForgotPasswordModal />
      {state.openModal === ModalTypeValue.ADD_BANK ? <AddBankModal /> : null}
      {state.openModal === ModalTypeValue.GAME_TRANSFER_POINT ? <ModalGameTransferPoint /> : null}
      {state.openModal === ModalTypeValue.CHECK_IN ? <RollCallModal /> : null}
      <ModalAnnouncement />
    </>
  );
};
